import { useMemo } from 'react';

import { useSettingsContext } from 'src/components/settings';

// ----------------------------------------------------------------------

export type LogoConfig = {
  fullLogo: string;
  singleLogo: string;
  darkModeFullLogo?: string;
  darkModeSingleLogo?: string;
};

export function useLogoConfig(): LogoConfig {
  const { state } = useSettingsContext();

  return useMemo<LogoConfig>(() => {
    const preset = typeof state?.primaryColor === 'string' ? state.primaryColor : 'default';

    const defaultConfig: LogoConfig = {
      fullLogo: 'logo-full.svg',
      singleLogo: 'logo-single.svg',
      darkModeFullLogo: 'logo-xpanse.svg',
      darkModeSingleLogo: 'xpanse-single-dark.png',
    };

    switch (preset) {
      case 'preset1':
        return {
          fullLogo: 'nvs-logo.png',
          singleLogo: 'nvs-logo-sm.png',
          darkModeFullLogo: 'nvs-logo-dark.png',
          darkModeSingleLogo: 'nvs-logo-sm.png',
        };

      case 'preset5':
        return {
          fullLogo: 'freedom-logo.png',
          singleLogo: 'logo-single.svg',
          darkModeFullLogo: 'freedom-logo.png',
          darkModeSingleLogo: 'xpanse-single-dark.png',
        };

      default:
        return defaultConfig;
    }
  }, [state?.primaryColor]);
}
